


export default function StoreTag({ name, marketplace, link = undefined }: { name: string, marketplace?: boolean, link?: string }) {

    const color = name === 'Best Buy'
        ? 'blue'
        : name === 'Brick'
            ? 'red'
            : name === 'Amazon'
                ? 'yellow'
                : name === 'Canada Computers'
                    ? 'indigo' : 'purple'

    if (link) {
        return <a href={link} className={`text-${color}-600 bg-${color}-100 px-2 py-0.5 rounded`}>
            {name} {marketplace ? '- marketplace' : null}
        </a>
    }

    return <span className={`text-${color}-600 bg-${color}-100 px-2 py-0.5 rounded`}>
        {name} {marketplace ? '- marketplace' : null}
    </span >
}
